import PolicyPage from "./PolicyPage";

export default function RefundPolicy() {
  return <PolicyPage testid="page-refund" policyKey="refund" />;
}
